export default __webpack_public_path__ + "static/media/grafema_design-factory-kitchen-pictograms_03.959ea205.jpg";